"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Box = _interopRequireDefault(require("../Box"));

var _Typography = require("../Typography");

var _UncheckedIcon = _interopRequireDefault(require("./src/UncheckedIcon"));

var _CheckedIcon = _interopRequireDefault(require("./src/CheckedIcon"));

var _IndeterminateIcon = _interopRequireDefault(require("./src/IndeterminateIcon"));

var _RadioGroupContext = _interopRequireDefault(require("../RadioGroup/RadioGroupContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Radio(_ref) {
  var checkedProp = _ref.checked,
      value = _ref.value,
      label = _ref.label,
      checkedIcon = _ref.checkedIcon,
      uncheckedIcon = _ref.uncheckedIcon,
      onChangeProp = _ref.onChange,
      color = _ref.color,
      props = _objectWithoutProperties(_ref, ["checked", "value", "label", "checkedIcon", "uncheckedIcon", "onChange", "color"]);

  var radioContext = _react["default"].useContext(_RadioGroupContext["default"]);

  var handleClick = function handleClick() {
    var event = {
      target: {
        value: value,
        checked: true
      }
    };
    onChangeProp && onChangeProp(event, value);
    radioContext.onChange && radioContext.onChange(event, value);
  };

  var checked = checkedProp;

  if (radioContext) {
    if (typeof checked === 'undefined') {
      checked = radioContext.value === value;
    }
  }

  return _react["default"].createElement(_Box["default"], _extends({}, props, {
    height: 36,
    display: "flex",
    alignItems: "center",
    onClick: handleClick,
    style: {
      cursor: 'pointer'
    }
  }), checked ? _react["default"].cloneElement(checkedIcon, {
    color: color
  }) : uncheckedIcon, label && _react["default"].createElement(_Typography.Text, {
    display: "inline-block",
    ml: 2
  }, label));
}

Radio.propTypes = {
  checked: _propTypes["default"].bool,
  onChange: _propTypes["default"].func
};
Radio.defaultProps = {
  uncheckedIcon: _react["default"].createElement(_UncheckedIcon["default"], null),
  checkedIcon: _react["default"].createElement(_CheckedIcon["default"], null) // indeterminateIcon: <IndeterminateIcon/>,

};
var _default = Radio;
exports["default"] = _default;